import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=f20b20f4&scoped=true"
import script from "./ErrorPage.vue?vue&type=script&lang=js"
export * from "./ErrorPage.vue?vue&type=script&lang=js"
import style0 from "./ErrorPage.css?vue&type=style&index=0&id=f20b20f4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20b20f4",
  null
  
)

export default component.exports